import { Dispatch } from 'redux';
import { PricingApi } from '../../../api/api.apiclient';
import { GET_RATE_PLAN_PERIODS } from '../types/rateplanperiod.types';

export const getRatePlanPeriods = () => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.RatePlan.listAllRatePlanPeriods();

  dispatch({
    type: GET_RATE_PLAN_PERIODS,
    payload: { page: response.data }
  });
};
